import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Modal from "../modals";
import { clearAllState } from "../../../helpers/storage";
import { ROUTES } from "../../../constants/routes";

const LogoutModal = () => {
  const [countdown, setCountdown] = useState(3);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      clearAllState();
      setRedirect(true);
    }, 3000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, []);

  if (redirect) {
    return <Navigate to={ROUTES.AUTH_PHONE_NUMBER} />;
  }

  return (
    <Modal size="small" isOpen={true} customClass="my-[15%]">
      <div className="bg-white rounded-xl mx-3">
        <div className="w-full flex flex-col items-center gap-4 border-b p-4 py-10">
          <img
            src="/assets/logout/logout-inactivity.png"
            className="w-44 h-44"
            alt=""
          />
          <div className="text-primary-900 text-[28px] font-bold leading-8 tracking-tight">
            You have been logged out
          </div>
          <div className="text-center text-[#999999] text-[15px] text-base font-normal leading-5">
            Redirecting you to log in in {countdown} sec..
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModal;
